import { Box, Typography } from "@mui/material";
import { FC, useState } from "react";
import chatBotWeb from "../../../assets/icons/ChatBotWeb.svg";
import chatBotMobile from "../../../assets/icons/ChatBotMobile.svg";
import "./ChatBot.scss";
import {
  tabViewPoint,
  GTAScreenType,
  SCREEN_TYPE,
} from "../../../utils/constants";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import TriggerGTAEvent from "../../../utils/GTA";
import { useAppSelector } from "../../../redux-store/CustomReduxHooks";
import useCmsPageVariables from "../../../hooks/useCmsPageVariables";
import useWindowSize from "../../../hooks/useWindowSize";
import useSaveChatbotActivity from "../../../hooks/useSaveChatbotActivity";
import RevampOnboardingPopup from "../../../pages/RevampOnboarding/RevampOnboardingPopup";
import { executeIfNotPseudoUser } from "../../../utils/helper";

const ChatBot: FC = () => {
  const cmsData = useCmsPageVariables("chatBotIcon");
  const [openOnboardingPopup, setOpenOnboardingPopup] =
    useState<boolean>(false);
  const mobileImage =
    cmsData?.attributes?.mobileImage?.data?.attributes?.url || chatBotMobile;
  const webImage =
    cmsData?.attributes?.image?.data?.attributes?.url || chatBotWeb;
  const { userDetails } = useAppSelector((state) => state.CsAppSlice);
  const { width } = useWindowSize();
  const { callSaveChatbotActivityAndRedirect } = useSaveChatbotActivity();
  const isPseudoLoggedIn = useAppSelector(
    (st) => st.PseudoLoginSlice.isPseudoLoggedIn,
  );

  const handleCleverTapCTAClick = () => {
    triggerCleverTapEvent("hd_simplify_bot_icon_click ", {
      ctaText: "simplify_bot_icon",
      ScreenType: SCREEN_TYPE.DashboardScreenType,
      ScreenName: "serv_homescreen",
      isPrevPageNameRequired: true,
    });
  };
  const handleGTMEvent = () => {
    TriggerGTAEvent("hd_simplify_bot_icon_click", {
      screen_type: GTAScreenType.DashboardScreenType,
      screen_name: "serv_homescreen",
      CTA_text: "simplify_bot_icon",
    });
  };
  const gotoOnBoardingPage = () => {
    setOpenOnboardingPopup(true);
  };
  const handleClick = async () => {
    executeIfNotPseudoUser(() => {
      handleCleverTapCTAClick();
      handleGTMEvent();
      if (!userDetails?.IS_USER_REGISTERED && !userDetails?.IS_NTB_USER) {
        gotoOnBoardingPage();
      } else {
        callSaveChatbotActivityAndRedirect();
      }
    }, isPseudoLoggedIn);
  };

  return (
    <>
      <Box onClick={handleClick}>
        {width > tabViewPoint ? (
          <Box className="chatbot" sx={{ cursor: "pointer" }}>
            <img src={webImage} className="chatbot-icon" alt="Chat Bot" />
            <Typography
              variant="subtitle2"
              sx={{ color: "#C7222A", textAlign: "center" }}
            >
              {cmsData?.attributes.title || "Ask SimpliFi"}
            </Typography>
          </Box>
        ) : (
          <Box className="chatbot-mobile">
            <img src={mobileImage} />
          </Box>
        )}
      </Box>
      {openOnboardingPopup && (
        <RevampOnboardingPopup
          open={openOnboardingPopup}
          handleOpen={setOpenOnboardingPopup}
          fromChatBot={true}
        />
      )}
    </>
  );
};

export default ChatBot;
